import axios from 'axios';
import { call, put } from 'redux-saga/effects';
import { get } from 'lodash';

import { setDataVersionAction } from 'actions/bankStatements';
import { getConfig, waitForConfig } from 'config/configService';

export const requestPending = (type) => `${type}_PENDING`;
export const requestSuccess = (type) => `${type}_SUCCESS`;
export const requestFail = (type) => `${type}_FAILURE`;

export const request = ({ type, method, url, apiUrl, nullData = false, headers, success, fail, payloadOnSuccess, payloadOnFail }) => function* apiRequest(action = {}) {
  const { data, params, onUploadProgress, success: successCallback, fail: failCallback } = action.payload || {};
  
  yield call(waitForConfig);
  const { apiUrl: defaultApiUrl } = getConfig();

  try {
    if (type) {
      yield put({
        type: requestPending(type),
        originalType: type,
      });
    }
    axios.defaults.baseURL = apiUrl || defaultApiUrl;

    const requestConfig = {
      url,
      method: method.toLowerCase(),
      headers: headers || {},
      params,
      onUploadProgress,
    };

    if (!nullData) {
      requestConfig.data = data || {};
    }

    const res = yield call(axios.request, requestConfig);

    const dataVersion = res.headers['x-lusa-data-version'];
    if (dataVersion) {
      yield put(setDataVersionAction(dataVersion));
    }

    if (type) {
      yield put({
        type: requestSuccess(type),
        payload: payloadOnSuccess ? payloadOnSuccess(res.data, action) : res.data,
        originalType: type,
      });
    }

    successCallback && successCallback(res.data);
    success && success(res.data, action);

    return res.data;
  } catch (err) {
    const errRes = get(err, 'response', err);
    const status = get(err, 'response.status');

    const errorPayload = status === 500
      ? { ...errRes, data: { failure: { errors: [{ message: `We're sorry for the interruption. An error has occurred. Please try again or contact our team at (844) 721-6961` }] } } }
      : errRes;

    failCallback && failCallback(errorPayload);
    fail && fail(errorPayload);

    if (type) {
      yield put({
        type: requestFail(type),
        payload: payloadOnFail ? payloadOnFail(errorPayload, action) : errorPayload,
        originalType: type,
      });
    }
    return null;
  }
};

export const getRequest = (params) => request({ ...params, method: 'get' });
export const postRequest = (params) => request({ ...params, method: 'post' });
export const putRequest = (params) => request({ ...params, method: 'put' });
export const deleteRequest = (params) => request({ ...params, method: 'delete' });

export default request;
